<template>

    <div id="wrapper">

				
        <form class="login-form">

            <img class="logo" src="~assets/img/Codium-PL-RGB-REV.png" alt="Codium" />

            <h1>Log In.</h1>

            <div class="form-group" v-if="!loggedInUser">
                <label class="control-label">Email</label>
                <input
                	class="form-control"
                    v-model="user.email"
                    placeholder=""
                    name="email">
            </div><!-- /.form-group -->

            <div class="form-group" v-if="!loggedInUser">
                <label class="control-label">Password</label>
                <input
                	class="form-control"
                    v-model="user.password"
                    type="password"
                    placeholder=""
                    name="password">
            </div><!-- /.form-group -->

            <div v-if="loggedInUser" class="form-group">
                <label class="control-label">Token</label>
                <input
                        class="form-control"
                        v-model="user.googleToken"
                        type="text"
                        placeholder=""
                        name="token">
            </div>

            <p class="m-t" @click="showQrcode = !showQrcode" v-if="loggedInUser && qrcode !== null"> <small>Show qrcode link</small> </p>

            <ladda-button :type="''" :on-click="handleLogin" class="btn btn-login btn-block">Log In</ladda-button>

            <router-link :to="{ path: '/auth/forgot' }" class="small">Forgot Password.</router-link>

            <img v-bind:src="qrcode" v-if="showQrcode">

        </form><!-- /.login-form -->

	</div><!-- /#wrapper -->

</template>

<script>
    import LaddaButton from 'components/form/input/ladda-button.vue'
    import { notify, auth } from 'utils'

    export default {
        components: {
            LaddaButton
        },

        data: function () {
            return {
                valid: false,
                user: {
                    email: "",
                    password: "",
                    googleToken: ""
                },
                loggedInUser: null,
                qrcode: '',
                showQrcode: false,
            }
        },
        methods: {
            handleLogin () {
                this.error = null

                return auth.attempt(this.user.email, this.user.password, this.user.googleToken).then(response => {
                  this.loggedInUser = response.data.user;
                  var token = response.token;

                  if (response.data.confirmed === true) {
                    this.$bus.$emit('userHasFetchedToken', token)
                    this.$bus.$emit('userHasLoggedIn', this.loggedInUser)
                    this.$router.push('/home')

                  } else {
                      if (this.user.googleToken.length > 0) {
                        notify.error('The token you provided seems to be incorrect.')
                      } else {
                        auth.getGoogleQR().then(response => {
                          this.qrcode = response.data.url
                        }).catch(error => {
                          notify.error(error.message)
                        })
                      }
                  }
                }).catch(error => {
                  if (error.response) {
                    if (error.response.status === 401) {
                      if (error.response.data.error === 'invalid_credentials') {
                        notify.error('The credentials you provided were invalid.')
                      }
                    } else if (error.response.status === 500) {
                      notify.error('There was a problem authenticating with the server.')
                    }
                  } else {
                    notify.error(error.message)
                  }
                })
            },

            /**
             * If any fields return validation error they will notify us
             * @param msg
             */
            onValidationError: function (msg) {
                this.valid = false;
            }
        }
    }
</script>